import { StrapiItem } from '../types/strapi/strapi';

export const getMetaFromStrapiSEO = (
  content: StrapiItem<unknown>,
  url: string,
  shouldIndex = true
): any[] => {
  const seo = content.attributes.seo;
  if (!seo) {
    console.error('No SEO data found for content', content.id);
    return [];
  }
  const properties = [
    { hid: 'title', name: 'title', content: seo.metaTitle },
    { hid: 'description', name: 'description', content: seo.metaDescription },
    { hid: 'og-type', property: 'og:type', content: 'article' },
    { hid: 'og-title', property: 'og:title', content: seo.metaTitle },
    { hid: 'og-description', property: 'og:description', content: seo.metaDescription },
    { hid: 'keywords', name: 'keywords', content: seo.keywords },
    {
      hid: 'og-image',
      property: 'og:image:secure_url',
      content: seo.metaImage?.data.attributes.url || '/images/share_image.png',
    },
    {
      hid: 'og-image',
      property: 'og:image',
      content: seo.metaImage?.data.attributes.url || '/images/share_image.png',
    },
    {
      hid: 'og-image-alt',
      property: 'og:image:alt',
      content:
        seo.metaImage?.data.attributes.alternativeText ||
        'Engaged, interactive and joyful classrooms start here',
    },
    {
      hid: 'og-image-width',
      property: 'og:image:width',
      content: seo.metaImage?.data.attributes.width || '1200',
    },
    {
      hid: 'og-image-height',
      property: 'og:image:height',
      content: seo.metaImage?.data.attributes.height || '630',
    },
    { hid: 'og-url', property: 'og:url', content: url },
    {
      hid: 'og-locale',
      property: 'og:locale',
      content: 'en_' + content.attributes.locale,
    },
    {
      hid: 'article-published_time',
      property: 'article:published_time',
      content: content.attributes.publishedAt,
    },
    {
      hid: 'article-modified_time',
      property: 'article:modified_time',
      content: content.attributes.updatedAt,
    },
  ];

  if (!shouldIndex) {
    properties.push({ hid: 'robots', name: 'robots', content: 'noindex' });
    properties.push({ hid: 'googlebot', name: 'googlebot', content: 'noindex' });
  }

  if (seo.metaSocial?.length) {
    const twitter = seo.metaSocial.find(s => s.socialNetwork === 'Twitter');
    if (twitter) {
      properties.push({ hid: 'twitter-title', name: 'twitter:title', content: twitter.title });
      properties.push({
        hid: 'twitter-description',
        name: 'twitter:description',
        content: twitter.description,
      });
      properties.push({
        hid: 'twitter-image',
        name: 'twitter:image',
        content: twitter.image.data.attributes.url,
      });
    }
  }

  return properties;
};
